import React from 'react';
import cx from 'classnames';
import styles from './FormContainer.module.scss';

export default function FormContainer(props) {
  const { children, className, title, caption } = props;
  return (
    <div className={cx(styles.formContainer, className)}>
      <h1 className={styles.titleStyle}>{title}</h1>
      {caption && <p>{caption}</p>}
      {children}
    </div>
  );
}
